import React, { useState } from "react";
import { minutesToUnitText, unitTextToMinutes } from "../utils/timeUnits";

type HoursInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "type"> & {
  /** Вредност во МИНУТИ (стринг како во редот). */
  minutes: string;
  /** Се вика со МИНУТИ (стринг) — празно кога полето е празно. */
  onMinutesChange: (minutes: string) => void;
  /** ЕМ на машината е час → „0:30“ (default); min → „30“. */
  hourUnit?: boolean;
};

/**
 * Поле за време: корисникот гледа и пишува во ЕМ на машината — часови:минути за час, минути за min —
 * а редот останува во минути.
 * Додека се пишува, се држи текстот како што е внесен („0,") за да не се пребришува на секој знак.
 */
const HoursInput = React.forwardRef<HTMLInputElement, HoursInputProps>(
  ({ minutes, onMinutesChange, onBlur, hourUnit = true, ...rest }, ref) => {
    const [draft, setDraft] = useState<string | null>(null);
    return (
      <input
        {...rest}
        ref={ref}
        type="text"
        inputMode="decimal"
        value={draft ?? minutesToUnitText(minutes, hourUnit)}
        onChange={(e) => {
          const text = e.target.value;
          setDraft(text);
          const value = unitTextToMinutes(text, hourUnit);
          onMinutesChange(value === null ? "" : String(value));
        }}
        onBlur={(e) => {
          setDraft(null);
          onBlur?.(e);
        }}
      />
    );
  }
);

HoursInput.displayName = "HoursInput";

export default HoursInput;
